import axios from 'axios'
import { CATALOGO_ENDPOINT } from 'common/endpoints'

export async function downloadSummary(stocks, translator, stockToProcess) {
  const body = { stocks, translator, stockToProcess }
  const response = await axios.post(
    `${CATALOGO_ENDPOINT}/generateStockSummaryExcel`,
    body,
    { responseType: 'blob' }
  )

  if (response.status === 200) {
    return response.data
  }
}